import React from "react";
import LogoTwinexa from "../../assets/img/LogoTwinexa.png";
import "./Footer.css";

function Footer() {
  return (
    <footer className="twinexa-footer">
      <div className="footer-content">
        <div className="footer-text">
          <span className="powered-by">Powered by</span>
          <a
            href="https://twinexa.com"
            target="_blank"
            rel="noopener noreferrer"
            className="twinexa-link"
          >
            <img
              src={LogoTwinexa}
              alt="Twinexa"
              className="twinexa-logo bg-dark"
            />
          </a>
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Twinexa. Software solutions for your business.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
